"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./flash-messages.service');
var ɵngcc2 = require('@angular/common');

function FlashMessagesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} }
function FlashMessagesComponent_div_2_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function FlashMessagesComponent_div_2_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); var message_r2 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.close(message_r2)); });
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd()();
} }
var _c0 = function (a0) { return { "alert-dismissible": a0 }; };
function FlashMessagesComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function FlashMessagesComponent_div_2_Template_div_click_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); var message_r2 = restoredCtx.$implicit; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.alertClicked(message_r2)); });
    ɵngcc0.ɵɵtemplate(1, FlashMessagesComponent_div_2_button_1_Template, 3, 0, "button", 5);
    ɵngcc0.ɵɵelement(2, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var message_r2 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("alert flash-message ", message_r2.cssClass, "");
    ɵngcc0.ɵɵstyleProp("cursor", message_r2.closeOnClick ? "pointer" : "inherit");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c0, message_r2.showCloseBtn));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", message_r2.showCloseBtn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", message_r2.text, ɵngcc0.ɵɵsanitizeHtml);
} }
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var flash_message_1 = require("./flash-message");
var flash_messages_service_1 = require("./flash-messages.service");
var FlashMessagesComponent = /** @class */ (function () {
    function FlashMessagesComponent(_flashMessagesService, _cdRef) {
        this._flashMessagesService = _flashMessagesService;
        this._cdRef = _cdRef;
        this._defaults = {
            text: 'default message',
            closeOnClick: false,
            showCloseBtn: false,
            cssClass: ''
        };
        this.messages = [];
        this.classes = '';
        this._grayOut = false;
        this._flashMessagesService.show = this.show.bind(this);
        this._flashMessagesService.grayOut = this.grayOut.bind(this);
    }
    FlashMessagesComponent.prototype.ngOnInit = function () { };
    FlashMessagesComponent.prototype.show = function (text, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var defaults = {
            timeout: 2500,
            closeOnClick: false,
            showCloseBtn: false,
            cssClass: '',
            text: "default message"
        };
        for (var attrname in options) {
            defaults[attrname] = options[attrname];
        }
        var message = new flash_message_1.FlashMessage(text, defaults.cssClass, defaults.closeOnClick, defaults.showCloseBtn);
        message.timer = window.setTimeout(function () {
            _this._remove(message);
            _this._cdRef.detectChanges();
        }, defaults.timeout);
        this.messages.push(message);
        this._cdRef.detectChanges();
    };
    FlashMessagesComponent.prototype.close = function (message) {
        clearTimeout(message.timer);
        this._remove(message);
        this._cdRef.detectChanges();
    };
    FlashMessagesComponent.prototype.alertClicked = function (message) {
        if (message.closeOnClick) {
            this.close(message);
        }
    };
    FlashMessagesComponent.prototype.grayOut = function (value) {
        if (value === void 0) { value = false; }
        this._grayOut = value;
    };
    FlashMessagesComponent.prototype._remove = function (message) {
        this.messages = this.messages.filter(function (msg) { return msg.id !== message.id; });
    };
    FlashMessagesComponent = __decorate([ __metadata("design:paramtypes", [flash_messages_service_1.FlashMessagesService, core_1.ChangeDetectorRef])
    ], FlashMessagesComponent);
FlashMessagesComponent.ɵfac = function FlashMessagesComponent_Factory(t) { return new (t || FlashMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FlashMessagesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FlashMessagesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FlashMessagesComponent, selectors: [["flash-messages"]], decls: 3, vars: 2, consts: [["id", "flashMessages", 1, "flash-messages"], ["id", "grayOutDiv", 4, "ngIf"], [3, "class", "ngClass", "cursor", "click", 4, "ngFor", "ngForOf"], ["id", "grayOutDiv"], [3, "ngClass", "click"], ["type", "button", "class", "close", "data-dismiss", "alert", "aria-label", "Close", 3, "click", 4, "ngIf"], [3, "innerHTML"], ["type", "button", "data-dismiss", "alert", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"]], template: function FlashMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FlashMessagesComponent_div_1_Template, 1, 0, "div", 1);
        ɵngcc0.ɵɵtemplate(2, FlashMessagesComponent_div_2_Template, 3, 10, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._grayOut && ctx.messages.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messages);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FlashMessagesComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'flash-messages',
                template: "\n      <div id=\"flashMessages\" class=\"flash-messages\">\n          <div id=\"grayOutDiv\" *ngIf='_grayOut && messages.length'></div>\n          <div class=\"alert flash-message {{message.cssClass}}\" [ngClass]=\"{'alert-dismissible':message.showCloseBtn}\" [style.cursor]=\"message.closeOnClick?'pointer':'inherit'\" *ngFor='let message of messages' (click)=\"alertClicked(message)\">\n              <button *ngIf=\"message.showCloseBtn\" type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"close(message)\"><span aria-hidden=\"true\">&times;</span></button>\n              <div [innerHTML]=\"message.text\"></div>\n          </div> \n      </div>\n  "
            }]
    }], function () { return [{ type: ɵngcc1.FlashMessagesService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
    return FlashMessagesComponent;
}());
exports.FlashMessagesComponent = FlashMessagesComponent;

